import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AdminActionLogs from "../pages/dashboardPage/logs/adminActionLogs/AdminActionLogs";
import RoomInformationEfficiency from "../pages/dashboardPage/logs/roomInformationEfficiency/RoomInformationEfficiency";

// Tab id (permissionCatalog "logs") → its page.
const TAB_PAGES = {
  "action-logs": AdminActionLogs,
  "room-efficiency": RoomInformationEfficiency,
};

const LogsNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("logs", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default LogsNavigator;
